var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment, createContext, useContext, useMemo, Children, } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { Button } from './Button';
import { groupBy } from 'lodash';
var StepContext = createContext({
    go: function () { },
    numberOfSteps: 0,
    currentStepNumber: 0,
    isFinalStep: false,
    canGoNext: false,
});
export function useStepContext() {
    return useContext(StepContext);
}
export var StepContainer = function (_a) {
    var _b;
    var unfilteredChildren = _a.children, onFinish = _a.onFinish;
    var location = useLocation();
    var history = useHistory();
    var _c = useMemo(function () {
        return groupBy(Children.toArray(unfilteredChildren), function (child) {
            return child && child.type === Step ? 'steps' : 'children';
        });
    }, [unfilteredChildren]), steps = _c.steps, children = _c.children;
    var step = ((_b = location.state) === null || _b === void 0 ? void 0 : _b.step) || 0;
    if (step < 0 || step > steps.length) {
        history.push(location.pathname, __assign(__assign({}, location.state), { step: 0 }));
        return null;
    }
    var currentStep = steps[step];
    var go = function (n) {
        var nextStep = step + n;
        if (currentStep.props.validate && !currentStep.props.validate())
            return;
        if (nextStep < 0 || nextStep >= steps.length)
            return;
        history.push(location.pathname, __assign(__assign({}, location.state), { step: nextStep }));
    };
    return (jsx(StepContext.Provider, { value: {
            currentStep: currentStep,
            go: go,
            numberOfSteps: steps.length,
            currentStepNumber: step + 1,
            isFinalStep: step === steps.length - 1,
            onFinish: onFinish,
            formId: currentStep.props.formId,
            canGoNext: currentStep.props.canGoNext !== false,
        } },
        currentStep,
        children));
};
export var Step = function (_a) {
    var children = _a.children;
    return jsx(Fragment, null, children);
};
export var NextButton = function (_a) {
    var children = _a.children, icon = _a.icon, onClick = _a.onClick, props = __rest(_a, ["children", "icon", "onClick"]);
    var _b = useStepContext(), isFinalStep = _b.isFinalStep, go = _b.go, formId = _b.formId, onFinish = _b.onFinish, canGoNext = _b.canGoNext;
    return (jsx(Button, __assign({}, props, { onClick: isFinalStep
            ? onFinish
            : !formId
                ? function (e) {
                    if (onClick)
                        onClick(e);
                    if (e.defaultPrevented)
                        return;
                    go(1);
                    e.preventDefault();
                }
                : undefined, icon: isFinalStep ? icon : undefined, form: formId, type: formId ? 'submit' : 'button', disabled: !canGoNext }), isFinalStep ? (children) : (jsx(Fragment, null,
        "Next",
        jsx(FontAwesomeIcon, { icon: faChevronRight, sx: { ml: 2 } })))));
};
//# sourceMappingURL=StepContainer.js.map